<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M3.5 19.5V9" />
	<path d="M20.5 19.5v-6" />
	<path d="M3.5 13.5h17" />
	<path d="M3.5 16.6h17" />
	<path d="M6.2 13.5v-2.1h4.6v2.1" />
</svg>
